import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Problem } from "@/components/landing/Problem";
import { Services } from "@/components/landing/Services";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Pricing } from "@/components/landing/Pricing";
import { WhyMonthly } from "@/components/landing/WhyMonthly";
import { Faq } from "@/components/landing/Faq";
import { WhyChooseUs } from "@/components/landing/WhyChooseUs";
import { TrustBar } from "@/components/landing/TrustBar";
import { CallExplainer } from "@/components/landing/CallExplainer";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { ChatWidget } from "@/components/ChatWidget";
import { TapToCall } from "@/components/TapToCall";

export default function LandingPage() {
  return (
    <main className="bg-[#060D1A] text-slate-100">
      <Nav />
      <Hero />
      <Marquee />
      <Problem />
      <Services />
      <HowItWorks />
      <WhyChooseUs />
      <Pricing />
      <TrustBar />
      <WhyMonthly />
      <Faq />
      <CallExplainer />
      <Contact />
      <Footer />
      <ChatWidget />
      <TapToCall />
    </main>
  );
}
